import { Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
const ControlVisualAsociarDoc = ({setShowOpenDocument2,ShowOpenDocument2,SelectedObjectDocument2}) => {
  return (
    <Modal
    key={"open"}
    size="xl"
    fade={false}
    centered={true}
    isOpen={ShowOpenDocument2}
    toggle={() => setShowOpenDocument2(!ShowOpenDocument2)}
    backdrop="static"
    keyboard={false}
  >
    <ModalHeader toggle={() => setShowOpenDocument2(!ShowOpenDocument2)}>
      Control visual
    </ModalHeader>
    <ModalBody>
      <Col lg={12}>
        <Card>
          <CardBody>
            <Row>
              <Col lg={12}>
                <iframe
                  id="miIframe"
                  width="100%"
                  height="500px"
                  src={`${process.env.REACT_APP_URL}Document/FileLocal?PathFile=${SelectedObjectDocument2?.path}`
                
                }
                ></iframe>
                
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </ModalBody>
  </Modal>
  )
}

export default ControlVisualAsociarDoc